import React from 'react';
import { useGetContextQuery } from '../api/appAPI';
import { Context } from '../api/types/config';

interface ApiContextProps {
};
 
export const ApiContext: React.FC<ApiContextProps> = (props) => {

   const { data, error, isLoading } = useGetContextQuery();
    
   if(error) {
           return <span className='text-danger'>error loading context</span>;
   }

   if(isLoading) {
       return <span>loading</span>;
   }

   if(data) {
    return <span>{data.name} {data.url}</span>
   }
   return <span>Unknown</span>
}

 


